<template>
  <span
    v-bind:class="{
        'PlanejamentoAcaoFormContaCorrente__valor-negativo': (saldo < 0)
      }">
     {{ getMoney(saldo) }}
  </span>
</template>
<script>
import { mapGetters } from 'vuex';
import { getMoney } from '../../../../common/functions/helpers';

export default {
  name: 'ContaCorrenteTabelaSaldoAjustado',
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters('acaoSaldoContaCorrente', [
      'getContasCorrentes',
    ]),
    saldo() {
      return this.getContasCorrentes[this.id];
    },
  },
  methods: {
    getMoney,
  },
};
</script>
